// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2MhqI","file":"styles_file__1pclW"};